/// The purpose of this component is to display the ineligible message for a given resident
/// At time of writing this means that the resident is within the independent department in VCare

import React from "react";
import {useTranslation} from "react-i18next";

import "./ineligibleDisplay.sass";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";

export interface IIneligibleDisplayProps {
  residentName?: string;
  namespace?: string;
}

const IneligibleDisplay: React.FC<IIneligibleDisplayProps> = ({
  namespace = "residentadmin"
}) => {
  const {t} = useTranslation([
    "translation",
    "residentadmin",
    "saresidentadmin"
  ]);

  return (
    <div className="ineligible-display">
      <div className="ineligible-display-icon">
        <Icon source={IconSource.error} />
      </div>

      <div className="ineligible-display-message">
        {t(`${namespace}:labels.ineligibleMessage`)}
      </div>
    </div>
  );
};

export default IneligibleDisplay;
